import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "VotingElement__in" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Каждый день может быть высталена новая оценка. ")

import { ref, onMounted } from "vue";
import { useVoting } from "@/use/useVoting";

import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import VotingElement from "@/components/VotingElement.vue";
import UiText from "@/plugins/ui/components/typography/UiText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VotingModule',
  setup(__props) {

const { getStat } = useVoting();

const currentStat = ref<number>(0);

onMounted(async () => {
  const currentValue = await getStat();
  currentStat.value = Number(currentValue.avg);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCard, null, {
    header: _withCtx(() => [
      _createVNode(UiHeader, {
        title: "Оценить меню на сегодня",
        description: "Пожалуйста, оцените меню по шкале от одного до пяти, где 1 - не\n        понравилось, 5 - очень понравилось."
      })
    ]),
    default: _withCtx(() => [
      _createVNode(UiText, {
        level: "2",
        class: "VotingElement__avg"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(currentStat.value) + " средняя оценка на сегодня. ", 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(UiText, {
          level: "2",
          weight: "bold",
          class: "VotingElement__rating"
        }, {
          default: _withCtx(() => [
            _createVNode(VotingElement)
          ]),
          _: 1
        })
      ]),
      _createVNode(UiCaption, {
        level: "3",
        class: "VotingElement__help"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})